module.exports = __webpack_public_path__ + "img/borderMiddleBracketsWhite.01c03c63.svg";